const SHIPPER_LOGIN = 'shipper_login';
const SHIPPER_LOGOUT = 'shipper_logout';
const SHIPPER_SIGNUP_LOGIN_SUCCESSFUL = 'SA_shipper_signup_login_successful';
const SHIPPER_SIGNUP_LOGIN_FAILED = 'SA_shipper_signup_login_failed';

const auth = {
  login: ({ success, email, wrong_credentials }) => ({
    eventName: SHIPPER_LOGIN,
    eventData: { success, email, wrong_credentials },
  }),

  logout: () => ({
    eventName: SHIPPER_LOGOUT,
    eventData: {},
  }),

  signupLoginSuccessful: ({ companyName, email, country }) => ({
    eventName: SHIPPER_SIGNUP_LOGIN_SUCCESSFUL,
    eventData: { companyName, email, country },
  }),

  signupLoginFailed: ({ companyName, email, country }) => ({
    eventName: SHIPPER_SIGNUP_LOGIN_FAILED,
    eventData: { companyName, email, country },
  }),
};

export default auth;
